module.exports = __webpack_public_path__ + "img/certification-successful.4b83a2e8.png";